export const DEFAULT_COMMENT_TYPES = ['For Client', 'For PM'];

export const TASK_STATUS = {
	_NEW: 'New',
	ACCEPTED: 'Accepted',
	DECLINED: 'Declined',
	COMPLETED: 'Completed',
	CANCELLED: 'Cancelled',
	EMAILED: 'Emailed',
	AUTO_EMAILED: 'Auto-Emailed',
	PRETRANSLATED: 'Pretranslated',
	// SPLIT: 'Split',
	PARALLEL: 'Parallel with Next Step',
	IN_PROGRESS: 'In Progress',
	REOPEN_COMPLETED: 'Reopen Completed',
	READY_FOR_DELIVERY: 'Ready for Delivery',
};

export const USER_ROLES = {
	TRANSLATOR: 'Translator',
	EDITOR: 'Editor',
	REVIEWER: 'Reviewer',
	OTHER: 'Other',
};

export const getTaskEditor = (editorType) => {
	const editorTypes = Array.isArray(editorType)
		? editorType
		: String(editorType ?? 'bilingual')
			.split(',')
			.filter(Boolean);

	if (editorTypes.includes('light')) return 'light';
	if (editorTypes.includes('bilingual')) return 'translation';
	if (editorTypes.includes('monolingual')) return 'editing';

	return 'translation';
};

export const getTaskEditorUrl = (hash, editorType) =>
	`/web/${getTaskEditor(editorType)}/${hash}`;

export const TM_TYPES = {
	MASTER: 'Master',
	WORKING: 'Working',
	PROJECT: 'Project',
	ALIGNER: 'Aligner',
};

export const ALIGNMENT_SCORE_OPTIONS = [
	{ value: 100, label: '100%' },
	{ value: 95, label: '95%' },
	{ value: 85, label: '85%' },
	{ value: 75, label: '75%' },
	{ value: 65, label: '65%' },
	{ value: 55, label: '55%' },
	{ value: 0, label: '0%' },
];

export const getAlignmentScoreCategory = (value) => {
	if (value === null || value === undefined || value === '') return null;
	const score = Number(value);
	if (!Number.isFinite(score)) return null;
	if (score >= 100) return 100;
	if (score > 90) return 95;
	if (score > 80) return 85;
	if (score > 70) return 75;
	if (score > 60) return 65;
	if (score > 50) return 55;
	return 0;
};

export const TB_TYPES = {
	MASTER: 'Master',
	WORKING: 'Working',
	PROJECT: 'Project',
	ALIGNMENT: 'Alignment',
};

export const PROJECT_STATUS = {
	IN_PROGRESS: 'In Progress',
	COMPLETED: 'Completed',
	CANCELLED: 'Cancelled',
};

// Color "tone" for a project's status badge - shared by the PM dashboard's
// projects grid (views/dashboard/projects.jsx) and the project dashboard's
// own stat cards (views/projects/dashboard/statCards.jsx), so both places
// color a given status the same way. Keep this as the one source of truth -
// don't fork a second copy.
export const getProjectStatusTone = (project) => {
	if (project?.status === PROJECT_STATUS.CANCELLED) return 'cancelled';
	if (project?.status === PROJECT_STATUS.COMPLETED) return 'completed';
	if (project?.status === PROJECT_STATUS.IN_PROGRESS) return 'inProgress';
	return 'notStarted';
};

export const SEGMENT_STATUS = {
	DRAFT: 'draft',
	CONFIRMED: 'confirmed',
	REJECTED: 'rejected',
};
